export default __webpack_public_path__ + "static/media/snapchat.bbdb37c9.png";